import { useFeatureGate } from "@statsig/react-bindings";

import { featureFlag } from "@/context/FeatureFlagProvider/featureFlags";
import { useInfo } from "@/context/InfoProvider/InfoProvider";

import { useGeographies } from "../api/getGeographies";

type GeoEnabled =
  | {
      isLoading: true;
    }
  | {
      isLoading: false;
      isEnabled: boolean;
    };

export const useGeoEnabled = (): GeoEnabled => {
  const { value: isGeoEnabled } = useFeatureGate(featureFlag.scenariosWithGeography);
  const { value: isGeoEnabledFromModel } = useFeatureGate(
    featureFlag.scenarioGeographyEnabledFromModel
  );
  const { value: isScenariosApiEnabled } = useFeatureGate(featureFlag.scenarioBuilderApi);
  const { data: geographies } = useGeographies({
    config: {
      enabled: isGeoEnabled && isGeoEnabledFromModel,
    },
    isScenariosApiEnabled,
  });
  const { currentOrganization: organization } = useInfo();

  if (!isGeoEnabled) {
    return {
      isLoading: false,
      isEnabled: false,
    };
  }

  if (!isGeoEnabledFromModel) {
    return {
      isLoading: false,
      isEnabled: organization?.configuration?.isGeoEnabled ?? false,
    };
  }

  if (!geographies) {
    return {
      isLoading: true,
    };
  }

  return {
    isLoading: false,
    isEnabled: geographies.length > 0,
  };
};
